import useLayeredContent from './useLayeredContent'
import type { Page } from '../../utils/pages-config'

/** Nuxt Content/Zod coerces null seo to {} -- normalize back to undefined so || fallbacks work */
function normalizeSeo(page: Page): Page {
    if (page.seo && !page.seo.metaTitle && !page.seo.metaDescription) {
        return { ...page, seo: undefined }
    }
    return page
}

export function useContentPage() {
    const { queryAll, queryBySlug } = useLayeredContent()

    async function getPages() {
        return await queryAll<Page>('pages')
    }

    async function getPageBySeoName(seoName: string) {
        const page = await queryBySlug<Page>('pages', seoName)
        if (!page) return null
        return normalizeSeo(page)
    }

    return { getPages, getPageBySeoName }
}
